import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { environment } from 'src/environments/environment';
import { ItemModel } from '@app/models/failure/item.model';
import { ElrTooltip } from '@app/interface/asset.interface';

@Injectable({ providedIn: 'root' })
export class ItemService {

  private apiUrl = `${environment.apiUrl}/api/item/`;
  private apiUrlRedis = `${environment.apiUrl}/api/redis/`;

  constructor(private httpClient: HttpClient) { }

  public getItem(searchValue: any): Observable<ItemModel[]> {
    return this.httpClient.post<ItemModel[]>(`${this.apiUrl}`,searchValue,{});
  }

  public getItemRedis(controlCenter: string, seachValue: any): Observable<ItemModel[]> {
    return this.httpClient.get<ItemModel[]>(`${this.apiUrlRedis}${controlCenter}?searchKey=` + seachValue);
  }

  public getItemCache(controlCenter: string): Observable<ItemModel[]> {
    return this.httpClient.get<ItemModel[]>(`${this.apiUrlRedis}get?key=item-` + controlCenter);
  }

  public getItemByPage(searchValue: any): Observable<ItemModel[]> {
    return this.httpClient.post<ItemModel[]>(`${this.apiUrl}/byPageNo`,searchValue ,{});
  }

  public getItemGIS(searchValue: any): Observable<ItemModel[]> {
    return this.httpClient.post<ItemModel[]>(`${this.apiUrl}/GIS`, searchValue,{});
  }

  public getItemsByItemIds(itemsIds: number[]): Observable<ItemModel[]> {
    return this.httpClient.post<ItemModel[]>(`${this.apiUrl}/byItemIds/`, itemsIds ,{ });
  }

  public getItemById(itemId: string): Observable<ItemModel> {
    return this.httpClient.get<ItemModel>(`${this.apiUrl}/${itemId}`, {});
  }

  public getTooltipInfoByELR(elrRef: string) {
    return this.httpClient.get<ElrTooltip>(`${this.apiUrl}/${elrRef}/tooltipInfo/`, {});
  }

  public getProblemHistoryById(itemId: string, placeId: number) {
    return this.httpClient.get(`${this.apiUrl}/problemHistory/${itemId}/${placeId}`, {});
  }

}
